module.exports = __webpack_public_path__ + "img/P150T_weapon_114.c50c3ee8.png";